import { useState, useEffect } from 'react';

interface User {
  id: string;
  email: string;
  displayName?: string;
  name?: string;
  first_name?: string;
  last_name?: string;
  fullname?: string;
  full_name_display?: string;
  role?: string;
  phone?: string;
  country?: string;
  city?: string;
  address?: string;
  birthday?: string;
  gender?: number;
  gender_display?: string;
  avatar?: string;
  avatar_url?: string;
  is_active?: number;
  is_stop?: number;
  is_trader_13w?: number;
  language?: string;
  location?: string;
  postal_code?: string;
  referral_code?: string;
  roles?: [
    {
      display_name?: string;
      id?: number;
      name?: string;
      pivot?: {
        user_id?: number;
        role_id?: number;
        assigned_by?: string | null;
        assigned_at?: string;
        [key: string]: any;
      };
      assigned_at?: string;
      assigned_by?: string | null;
      created_at?: string;
      role_id?: number;
      updated_at?: string;
      user_id?: number;
      sort_order?: number;
    }
  ]
  assigned_roles?: any[];
  role_names?: string[];
  roles_display?: string;
  status?: number;
  status_display?: string;
  subscription_status?: string;
  cccd?: string;
  cccd_front_image?: string;
  cccd_front_image_url?: string;
  cccd_back_image?: string;
  cccd_back_image_url?: string;
  job_title?: string;
  manager_email?: string;
  manager_fullname?: string;
  manager_phone?: string;
  parent_id?: string;
  referral_code_used?: string;
  referrer_id?: string;
  settings?: string;
  telegram_id?: number;
  token_active?: string;
  trial_ends_at?: string;
  type?: number;
  username?: string;
  email_verified_at?: string;
  google_id?: string;
  google_email?: string;
  reset_pass_token?: string;
  invoice_detail?: any;
  [key: string]: any;
}

interface AuthState {
  user: User | null;
  isAuthenticated: boolean;
  token: string | null;
  loading: boolean;
}

export const useAuth = (): AuthState => {
  const [authState, setAuthState] = useState<AuthState>({
    user: null,
    isAuthenticated: false,
    token: null,
    loading: true
  });

  useEffect(() => {
    const initAuth = () => {
      const token = localStorage.getItem('token');
      const userString = localStorage.getItem('user');
      
      if (!token || !userString) {
        setAuthState({
          user: null,
          isAuthenticated: false,
          token: null,
          loading: false
        });
        return;
      }

      try {
        const localUser = JSON.parse(userString);
        const fullName = `${localUser.first_name || ''} ${localUser.last_name || ''}`.trim();
        
        setAuthState({
          user: {
            id: localUser.id,
            email: localUser.email,
            displayName: fullName || localUser.email,
            name: fullName,
            first_name: localUser.first_name,
            last_name: localUser.last_name,
            role: localUser.role,
            phone: localUser.phone,
            country: localUser.country,
            city: localUser.city,
            address: localUser.address,
            birthday: localUser.birthday,
            gender: localUser.gender,
            ...localUser
          },
          isAuthenticated: true,
          token,
          loading: false
        });
      } catch (error) {
        console.error('Error parsing user data:', error);
        localStorage.removeItem('user');
        localStorage.removeItem('token');
        setAuthState({
          user: null,
          isAuthenticated: false,
          token: null,
          loading: false
        });
      }
    };

    initAuth();
  }, []);

  return authState;
};
